/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LockCardOnFraudDetectedRequestOneOf
 */
export interface LockCardOnFraudDetectedRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf
     */
    'lockType': LockCardOnFraudDetectedRequestOneOfLockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockCardOnFraudDetectedRequestOneOf
     */
    'triggeredTransactionId': string;
}

export const LockCardOnFraudDetectedRequestOneOfLockTypeEnum = {
    vrm: 'VRM',
    transactionSpike: 'TRANSACTION_SPIKE',
    merchantLeakage: 'MERCHANT_LEAKAGE',
    suspiciousTransaction: 'SUSPICIOUS_TRANSACTION',
    threeDSecure: 'THREE_D_SECURE',
    rule: 'RULE'
} as const;

export type LockCardOnFraudDetectedRequestOneOfLockTypeEnum = typeof LockCardOnFraudDetectedRequestOneOfLockTypeEnum[keyof typeof LockCardOnFraudDetectedRequestOneOfLockTypeEnum];


